import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAllWorkersBySubserviceId } from "../../../services/workerFn";

// Async thunk to fetch product data
export const fetchWorker = createAsyncThunk(
  "home/fetchWorker",
  async (query) => {
    const response = await getAllWorkersBySubserviceId(
      query?.serviceId,
      query?.lat,
      query?.lng,
      query?.name,
      query?.rating,
      query?.date,
      query?.companyId
    );
    return response.data.data;
  }
);

const initialState = {
  isLoading: false,
  data: [],
  error: false,
};

// Worker slice
const workerSlice = createSlice({
  name: "worker",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorker.pending, (state) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(fetchWorker.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchWorker.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
      });
  },
});

export default workerSlice.reducer;
